import { Component, ContentChild, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { InputSwitch } from 'primeng/inputswitch';

@Component({
  selector: 'vnm-form-option',
  templateUrl: './form-option.component.html',
  styleUrls: ['./form-option.component.scss']
})
export class FormOptionComponent {
  @HostBinding('class.p-field') uiField = true;
  @ContentChild(InputSwitch) switchControl!: InputSwitch;

  @Input() label: string;
  @Input() info: string;
  @Input() help: string;
  @Input() configLink: string | string[];
  @Input() configLabel: string;

  @Output() tooltipClicked = new EventEmitter();
}
